import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faIdBadge,
  faUser,
  faBullhorn,
  faImages,
  faRightFromBracket,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

export default function AdminSidebar({ sidebarOpen, setSidebarOpen }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin-auth");
    localStorage.removeItem("admin-user");
    navigate("/login");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center px-3 py-2 rounded-md transition font-medium
     ${isActive ? "bg-gold text-deep-black" : "text-white hover:bg-white/10 hover:text-gold"}`;

  return (
    <>
      {/* OVERLAY (Mobile Only) */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/40 md:hidden z-0"
        ></div>
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          bg-deep-black text-white md:w-64 w-full p-6 pt-4 
          fixed md:static top-[152px] left-0 h-100 z-50
          transform transition-transform duration-300
          ${sidebarOpen ? "translate-y-[1px]" : "-translate-y-[500px] md:translate-y-0"}
        `}
      >
        <h2 className="text-2xl mb-4 font-bold hidden md:block text-gold">
          Admin Panel
        </h2>

        <nav className="space-y-2" onClick={() => setSidebarOpen(false)}>
          <NavLink to="/admin" end className={linkClass}>
            <FontAwesomeIcon icon={faChartLine} className="mr-3" />
            Dashboard
          </NavLink>

          <NavLink to="/admin/DesignationList" className={linkClass}>
            <FontAwesomeIcon icon={faIdBadge} className="mr-3" />
            Designation
          </NavLink>

          <NavLink to="/admin/personList" className={linkClass}>
            <FontAwesomeIcon icon={faUser} className="mr-3" />
            Person
          </NavLink>

          <NavLink to="/admin/ReleaseList" className={linkClass}>
            <FontAwesomeIcon icon={faBullhorn} className="mr-3" />
            Release
          </NavLink>

          <NavLink to="/admin/GallaryList" className={linkClass}>
            <FontAwesomeIcon icon={faImages} className="mr-3" />
            Gallery
          </NavLink>

          <NavLink to="/admin/InquiriesList" className={linkClass}>
            <FontAwesomeIcon icon={faEnvelope} className="mr-3" />
            Inquiries
          </NavLink>

          <button
            onClick={handleLogout}
            className="flex items-center px-3 py-2 rounded-md transition font-medium text-white hover:bg-white/10 hover:text-gold w-full text-left"
          >
            <FontAwesomeIcon icon={faRightFromBracket} className="mr-3" />
            Logout
          </button>
        </nav>
      </aside>
    </>
  );
}
